import React, { useCallback, useMemo, useState } from 'react'
import { Grid, TextField, InputAdornment, IconButton } from '@material-ui/core'
import Button from './Button'
import { ClearOutlined, SearchOutlined } from '@material-ui/icons'
import { validatePhone } from '../helpers'


const styles = {
  gap: {
    gap: '10px',
  },
}


export const InputTelSearch = ({
  onSubmit,
}) => {
  const [phone, setPhone] = useState('')
  const [submitCalled, setSubmitCalled] = useState(false)

  const disabled = useMemo(() => !validatePhone(phone), [phone])

  const handlePhoneChange = useCallback((e) => {
    setSubmitCalled(false)
    setPhone(e.target.value)
  }, [])

  const handleSubmit = useCallback(() => {
    const validatedPhone = validatePhone(phone)

    if (onSubmit && !!validatedPhone) {
      onSubmit(validatedPhone)
      setSubmitCalled(true)
    }
  }, [phone, onSubmit])

  const handleResetPhone = useCallback(() => {
    if (submitCalled) {
      onSubmit('')
    }

    setPhone('')
  }, [submitCalled, onSubmit])

  return (
    <Grid
      container
      wrap="nowrap"
      style={styles.gap}
    >
      <TextField
        fullWidth
        value={phone}
        placeholder="+33612345678"
        onChange={handlePhoneChange}
        label="Rechercher par numéro de téléphone"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlined />
            </InputAdornment>
          ),
          endAdornment: (
            <IconButton onClick={handleResetPhone} disabled={!phone}>
              <ClearOutlined />
            </IconButton>
          )
        }}
      />

      <Button disabled={disabled} color="primary" onClick={handleSubmit}>Rechercher</Button>
    </Grid>
  )
}
